import React from "react";

import { useDateRender } from "../../../hooks";
import { LabeledText } from "./LabeledText";

export interface LabeledDateProps {
    textFontSize?: number;
    direction?: "vertical" | "horizontal";
    labelFontSize?: number;
    label: string;
    value?: Date;
    testId?: string;
}

export const LabeledDateTime = ({
    value,
    label,
    textFontSize,
    direction,
    labelFontSize,
    testId
}: LabeledDateProps): JSX.Element => {
    const { renderDateTime } = useDateRender();

    return (
        <LabeledText
            label={label}
            value={value ? renderDateTime(value) : "-"}
            direction={direction}
            labelFontSize={labelFontSize}
            textFontSize={textFontSize}
            testId={testId}
        />
    );
};
